// extracted by mini-css-extract-plugin
export default {"fullscreenCell":"Sheet_fullscreenCell__6pvJ4"};